export default "__VITE_ASSET__jNVvIUKD__"